import { useSearchParams } from 'react-router-dom';

export const useQueryString = (value: string) => {
    const [searchParams] = useSearchParams();
    return searchParams.get(value);
};

export const useNextQueryStringValue = () => {
    return useQueryString('next') || undefined;
};

export const useErrorQueryStringValue = () => {
    return useQueryString('error');
};

export const useCloseOnSuccessQueryStringValue = () => {
    return useQueryString('closeOnSuccess') === 'true';
};
